import { memo } from 'react';
import { Legend } from 'recharts';

type RenderCustomLegendProps = {
  fontSize?: string;
};

const renderCustomLegend = (props: any) => {
  const { payload, fontSize } = props;

  return (
    <ul className='flex flex-wrap justify-center list-none p-0 gap-x-4 gap-y-2 m-0 w-full'>
      {payload.map((entry: any, index: number) => (
        <li
          key={`item-${index}`}
          className='text-[#161A1F] min-[1699px]:w-[35%] leading-5'
          style={{ fontSize: fontSize }}
        >
          <span
            style={{
              display: 'inline-block',
              width: 12,
              height: 12,
              backgroundColor: entry.color,
              marginRight: 4,
              borderRadius: '2px',
            }}
          ></span>
          {entry.value}
        </li>
      ))}
    </ul>
  );
};

const RenderCustomLegend = ({ fontSize }: RenderCustomLegendProps) => {
  return (
    <Legend
      content={(props) => renderCustomLegend({ ...props, fontSize })}
      verticalAlign='bottom'
      wrapperStyle={{ bottom: 15, left: 0, width: '100%' }}
    />
  );
};

export default memo(RenderCustomLegend);
